module.exports = __webpack_public_path__ + "static/media/comparison-available.3ba64b1e.png";